(function()
{
	var Debug = include('springroll.Debug');

	var Type = {
		String: 'string',
		Boolean: 'boolean',
		Number: 'number',
		Int: 'int'
	};

	var Options = [
	{
		name: 'autoScroll',
		type: Type.Number,
		log: 'Autofly straight, no collisions. If number, will set scroll speed..'
	},
	{
		name: 'bgIdx',
		type: Type.Int,
		log: '0..2.'
	},
	{
		name: 'bgLoops',
		type: Type.Int,
		log: 'Override the background loop count for all background sets.'
	},
	{
		name: 'clearTutorial',
		type: Type.Boolean,
		log: 'clear saved data if we did tutorial.'
	},
	{
		name: 'markerX',
		type: Type.Number,
		log: 'Distance to place flower at (in game "feet").'
	},
	{
		name: 'markerScore',
		type: Type.String,
		log: 'Score to display on high score marker.'
	},
	{
		name: 'invincible',
		type: Type.Boolean,
		log: 'Seeds can not be hurt by enemies.'
	},
	{
		name: 'mute',
		type: Type.Boolean,
		log: 'mute all sounds.'
	},
	{
		name: 'muteMusic',
		type: Type.Boolean,
		log: 'mute the music context'
	},
	{
		name: 'powerup',
		type: Type.String,
		log: '[\'Life\', \'Shield\', \'Hal\']. Jump to gameplay and test a specific powerup.'
	},
	{
		name: 'seeds',
		type: Type.String,
		log: 'How many seeds to start with'
	},
	{
		name: 'segment',
		type: Type.String,
		log: 'a specific index or comma-separated String for testing out level segments.'
	},
	{
		name: 'showCollision',
		type: Type.Boolean,
		log: 'show collision polygons.'
	},
	{
		name: 'skipIntro',
		type: Type.Boolean,
		log: 'skip Nature Cat\'s introduction.'
	},
	{
		name: 'skipLaunch',
		type: Type.Boolean,
		log: 'Start flight.'
	},
	{
		name: 'skipTut',
		type: Type.Boolean,
		log: 'skip the tutorial automatically.'
	},
	{
		name: 'state',
		type: Type.String,
		log: 'title, game.'
	},
	{
		name: 'testHal',
		type: Type.Boolean,
		log: 'Skip flight and bring Hal in right away.'
	},
	{
		name: 'tutorial',
		type: Type.String,
		log: 'default: enable tutorial/ string = start at task (provide Task enum name, e.g. \'Fly, Instructions, Breeze\'.'
	},
	{
		name: 'volume',
		type: Type.Number,
		log: '0.0-1 Set the context of all volumes at init'
	}];

	var DebugOptions = {
		init: function()
		{
			var query = springroll.Application.instance.options;
			for (var i = 0; i < Options.length; i++)
			{
				var o = Options[i];
				if (query[o.name])
				{
					DebugOptions[o.name] = query[o.name];
				}
				else
				{
					DebugOptions[o.name] = null;
				}
				if (DEBUG)
				{
					if (springroll.DebugOptions[o.type])
					{
						springroll.DebugOptions[o.type](o.name, o.log);
					}
					else
					{
						if (Debug) Debug.error('springroll.DebugOptions[' + o.type + '] is not a function');
					}
				}
			}

			// Log out on the options
			if (DEBUG)
			{
				springroll.DebugOptions.log();
			}

			// Game specific linkages/overrides; if one option requires the other, create a default linkage
			if (DEBUG)
			{
				if (this.powerup ||
					(DebugOptions.tutorial && DebugOptions.tutorial !== true))
				{
					this.skipLaunch = true;
				}
			}
		}
	};

	namespace('nature').DebugOptions = DebugOptions;
}());
